<!-- <section class="welcome-section"> -->
<div class="welcome-container my-5">
  <h1 class="Welcome-title text-center pb-5">Welcome, {{user.Name}}!</h1>


  <!-- <div class="container my-5"> -->
  <div class="card-container mx-auto p-3 mb-5 mt-4" style="max-width: 1100px;">
    <div class="row g-5 px-5 justify-content-center ">
      <div class="col-md-4 px-5  ">
        <div class="card p-5 rounded-4 m-3" (click)="addUserTag()">
          <div class="card-icon ">
            <img src="assets/images/task_assign.png" alt="task-assign">
          </div>
          <h6 class="fw-bold text-color fs-5">Assign<br> Assessment</h6>
        </div>
      </div>
      <div class="col-md-4 px-5">
        <div class="card p-5  rounded-4 m-3" (click)="viewProgress()">
          <div class="card-icon">
            <img src="assets/images/progress-report.png" alt="progress-report">
          </div>
          <h6 class="fw-bold text-color fs-5">View <br>Progress</h6>
        </div>
      </div>
      <div class="col-md-4 px-5">
        <div class="card p-5 rounded-4 m-3" (click)="addNewTeamOrUser()">
          <div class="card-icon">
            <img src="assets/images/team-user.png" alt="team_user">
          </div>
          <h6 class="fw-bold text-color fs-5">Add New User / Team</h6>
        </div>
      </div>
    </div>

  </div>


  <!-- </div> -->
</div>

<!-- </section> -->